module.exports = __webpack_public_path__ + "img/question_creation_management.ee9e7b60.png";